import React from 'react';
import { Link } from 'react-router-dom';

const CollegeOfSpiritualStudies = () => {
  const programs = [
    {
      title: "Division of Christian Counseling and Psychology",
      description: "Comprehensive training in faith-based counseling and psychological principles for ministry and professional practice.",
      path: "/academics/division_christian_counseling",
      icon: "🎓"
    },
    {
      title: "Master of Arts in Christian Counseling",
      description: "Advanced study program combining theological foundations with counseling psychology.",
      path: "/academics/ma_christian_counseling",
      icon: "📚"
    }
    // Add more programs as needed
  ];

  // Updated program link style for both components
  const ProgramLink = ({ title, description, path, icon }) => (
    <Link 
      to={path}
      className="block bg-white rounded-xl shadow-sm p-8 hover:shadow-md transition-all duration-300 group"
    >
      <div className="flex items-start gap-4">
        <span className="text-2xl">{icon}</span>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className="text-xl font-semibold group-hover:text-primary-600 transition-colors">
              {title}
            </h3>
            <span className="text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
              →
            </span>
          </div>
          <p className="text-gray-600 mt-2">{description}</p>
        </div>
      </div>
    </Link>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-700">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto text-center text-white">
            <h1 className="text-4xl font-bold mb-4">
              Jakhotia College of Spiritual Studies
            </h1>
            <p className="text-xl opacity-90">
              Developing skilled ministry leaders through practical and theological education
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          {/* Overview Section */}
          <section className="mb-16">
            <div className="bg-white rounded-xl shadow-sm p-8">
              <h2 className="text-2xl font-bold mb-6">About Our College</h2>
              <p className="text-gray-600 text-lg leading-relaxed mb-4">
                Hamilton College of the Bahamas' Jakhotia College of Spiritual Studies consists of 
                programs designed to help pastors and ministry leaders develop their ministry skills. 
                Whether their goal is advanced ministry opportunities, movement into another area of 
                ministry, or personal achievement, we offer a course of study to meet each student's needs.
              </p>
              <p className="text-gray-600 text-lg leading-relaxed">
                Our professors bring decades of active ministry experience to the classroom, 
                combining theoretical knowledge with practical application. Their goal is to mentor 
                pastors and ministry professionals to help them achieve their highest potential.
              </p>
            </div>
          </section>

          {/* Mission Section */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold mb-6">Our Mission</h2>
            <div className="grid gap-6">
              <div className="bg-white rounded-xl shadow-sm p-8 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-2 h-full bg-primary-500"></div>
                <h3 className="text-xl font-semibold mb-4">Educational Excellence</h3>
                <p className="text-gray-600">
                  To provide affordable, high-quality graduate and post-graduate education for men 
                  and women actively engaged in Christian service.
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-8 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-2 h-full bg-primary-500"></div>
                <h3 className="text-xl font-semibold mb-4">Critical Thinking & Research</h3>
                <p className="text-gray-600">
                  To challenge students through critical thinking, research, and writing to develop 
                  a sound biblical worldview and hermeneutic and to express them clearly to the 
                  contemporary culture.
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-sm p-8 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-2 h-full bg-primary-500"></div>
                <h3 className="text-xl font-semibold mb-4">Christian Service</h3>
                <p className="text-gray-600">
                  To equip Christians to use their intellect, skills, and gifts in building up 
                  the Body of Christ, engaging and reaching the greater world, and ministering 
                  to the varied physical, spiritual, and emotional needs of their fellow human beings.
                </p>
              </div>
            </div>
          </section>

          {/* Programs Section */}
          <section className="mb-16">
            <h2 className="text-2xl font-bold mb-6">Our Programs</h2>
            <div className="grid gap-6">
              {programs.map((program, index) => (
                <ProgramLink 
                  key={index}
                  title={program.title}
                  description={program.description}
                  path={program.path}
                  icon={program.icon}
                />
              ))}
            </div>
          </section>

          {/* CTA Section */}
          <section>
            <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl p-8 text-center">
              <h2 className="text-2xl font-bold mb-4">Begin Your Spiritual Journey</h2>
              <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
                Take the first step towards advancing your ministry skills and theological education.
                Join our community of dedicated scholars and practitioners.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link
                  to="/application"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-lg text-white bg-primary-600 hover:bg-primary-700 transition-colors duration-200 shadow-sm hover:shadow"
                >
                  Apply Now
                </Link>
                <Link
                  to="/request"
                  className="inline-flex items-center justify-center px-6 py-3 rounded-lg text-primary-700 bg-white border border-primary-200 hover:bg-primary-50 transition-colors duration-200"
                >
                  Request Information
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CollegeOfSpiritualStudies; 